<template>
	<footer id="site-footer" class="in-module" role="contentinfo" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
    <a href="#app" class="pagetop">▲ ページの先頭へ</a>
    <div class="max">
      <div class="company">
        <figure><img src="/images/common/logo.webp" alt="rokuza"></figure>
        <dl>
          <dt>南房総・館山【鏡ヶ浦温泉rokuza ロクザ】</dt>
          <dd>〒294-0055 千葉県館山市那古1672-88<br>Tel.0470-20-5693【受付時間】10:00～21:00</dd>
          <dd>
            <ul class="sns">
              <li itemprop="name"><a itemprop="url" href="https://www.facebook.com/amimotonoyado.rokuya" target="_blank" rel="nofollow" area-label="FaceBook"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M17.525,9H14V7c0-1.032,0.084-1.682,1.563-1.682h1.868v-3.18C16.522,2.044,15.608,1.998,14.693,2C11.98,2,10,3.657,10,6.699V9H7v4l3-0.001V22h4v-9.003l3.066-0.001L17.525,9z"/></svg></a></li>
              <li itemprop="name"><a itemprop="url" href="https://www.instagram.com/rokuya_official/?hl=ja" target="_blank" rel="nofollow" area-label="Instagram"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M16,3H8C5.239,3,3,5.239,3,8v8c0,2.761,2.239,5,5,5h8c2.761,0,5-2.239,5-5V8C21,5.239,18.761,3,16,3z M12,17c-2.761,0-5-2.239-5-5s2.239-5,5-5s5,2.239,5,5S14.761,17,12,17z M18,7c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S18.552,7,18,7z"/><circle cx="12" cy="12" r="3"/></svg></a></li>
            </ul>
          </dd>
        </dl>
      </div>
      <nav>
        <dl>
          <dt>サイトメニュー</dt>
          <dd>
            <ul>
              <li itemprop="name"><a itemprop="url" href="/">トップページ</a></li>
              <li itemprop="name"><a itemprop="url" href="/concept/">コンセプト</a></li>
              <li itemprop="name"><a itemprop="url" href="/cuisine/">お料理</a></li>
              <li itemprop="name"><a itemprop="url" href="/rooms/">お部屋</a></li>
              <li itemprop="name"><a itemprop="url" href="/spa/">鏡ヶ浦温泉</a></li>
              <li itemprop="name"><a itemprop="url" href="/facilities/">館内施設</a></li>
              <li itemprop="name"><a itemprop="url" href="/access/">アクセス</a></li>
              <li itemprop="name"><a itemprop="url" href="/news/">お知らせ</a></li>
              <li itemprop="name"><a itemprop="url" href="/faq/">よくあるご質問</a></li>
              <li itemprop="name"><a itemprop="url" href="/">プライバシーポリシー</a></li>
            </ul>
          </dd>
        </dl>
        <dl class="one">
          <dt>ご予約・お問い合わせ</dt>
          <dd>
            <ul class="one">
              <li itemprop="name"><a itemprop="url" href="/" target="_blank">お問い合わせ</a></li>
              <li><a href="https://reserve.489ban.net/client/rokuza/0/plan/availability/room">ご宿泊予約</a></li>
              <li><a href="https://reserve.489ban.net/client/rokuza/0/booked/login?_ga=2.56667946.1803933193.1782708206-45593248.1778580001">予約確認・変更・キャンセル</a></li>
            </ul>
          </dd>
        </dl>
      </nav>
    </div>
    <small class="copy">Copyright &copy; {{ currentYear }} Rokuya All rights reserved.</small>
	</footer>
</template>

<style lang="scss" scoped>
footer{
  background: module.tone(module.$gray, -.5);
  color: module.$normal;
  a{
    color: module.$normal;
  }
  .pagetop{
    background: module.tone(module.$gray, -.5);
    border-bottom: module.tone(module.$gray, -1.1) 1px solid;
    display: block;
    text-align: center;
    padding: 1rem 0;
  }
  .max{
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: module.side2x();
    padding: 4.8rem module.side();
    @media screen and (max-width: module.$tab){
      grid-template-columns: 1fr;
    }
  }
  .company{
    display: grid;
    grid-template-columns: 4.4rem 1fr;
    grid-gap: 2rem;
    @media screen and (max-width: module.$tab){
      justify-self: center;
    }
    @media screen and (max-width: module.$phone){
      grid-template-columns: 4rem 1fr;
    }
    figure{
      img{
        width: 100%;
        object-fit: cover;
      }
    }
    dl{
      line-height: 1.56;
      @media screen and (max-width: module.$phone){
        font-size: .92rem;
      }
      dd{
        font-size: .72rem;
        margin: .4rem 0 0;
      }
    }
    .sns{
      padding: .8rem 0 0;
      @include module.flex();
      align-items: center;
      justify-content: flex-start;
      li{
        margin: 0 .64rem 0 0;
        &:last-child{
          margin: 0;
        }
        a{
          width: 2.8rem;
          height: 2.8rem;
          background: module.$white;
          @include module.flex();
          align-items: center;
          justify-content: center;
          border-radius: .4rem;
          position: relative;
          transition: all 320ms module.$ease;
          &:hover{
            background: module.$normal;
            svg{
              fill: module.$white;
            }
          }
          svg{
            width: 1.32rem;
            height: 1.32rem;
            fill: module.$normal;
            position: relative;
            z-index: 2;
            transition: all 320ms module.$ease;
          }
        }
      }
    }
  }
  nav{
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 3.2rem;
    dl{
      dt{
        font-size: 1rem;
        font-weight: 700;
        margin: 0 0 .8rem;
        padding: 0 0 .64rem;
        border-bottom: module.tone(module.$gray, -1.1) 1px solid;
        position: relative;
        &:after{
          content: '';
          width: 3.2rem;
          height: 1px;
          position: absolute;
          left: 0;
          bottom: -1px;
          background: module.$normal;
        }
      }
      dd{
        font-size: .88rem;
        ul{
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-column-gap: 1.6rem;
          &.one{
            grid-template-columns: repeat(1, 1fr);
          }
        }
      }
    }
  }
  small{
    display: block;
    text-align: center;
    font-size: .72rem;
    border-top: rgba(module.$white,.04) .1rem solid;
    padding-bottom: calc(var(--reservation-fix-area) + 3.2rem);
  }
}
</style>

<script>
export default {
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	}
}
</script>